import { AuctionLotModel, InvoiceModel } from "./";

export class InvoiceItemModel {
    Id: number
    InvoiceId: number;
    AuctionLotId: number;
    AuctionLot: AuctionLotModel;
    Invoice: InvoiceModel;
}